<template>
    <div class="app-container">
      <div class="main">
        <div class="main-title">投诉处置</div>
  
        <div class="sub blue">
          <div class="sub-title">投诉信息</div>
          <div class="text item">
            {{ "投诉编号" }}&nbsp;:&nbsp;{{ logIdList.complaintCode }}
          </div>
          <div class="text item">
            {{ "项目名称" }}&nbsp;:&nbsp;{{ logIdList.projectName }}
          </div>
          <div class="text item">
            {{ "总包单位" }}&nbsp;:&nbsp;{{ logIdList.generalContractor }}
          </div>
          <div class="text item">
            {{ "分包单位" }}&nbsp;:&nbsp;{{ logIdList.subcontractor }}
          </div>
          <div class="text item">
            {{ "负责人联系方式" }}&nbsp;:&nbsp;{{ logIdList.phone }}
          </div>
        </div>
  
        <div class="sub gray">
          <div class="sub-title">投诉内容</div>
          <div class="text item">
            {{ "投诉人" }}&nbsp;:&nbsp;{{ logIdList.userId }}
          </div>
          <div class="text item">
            {{ "岗位" }}&nbsp;:&nbsp;{{ logIdList.position }}
          </div>
          <div class="text item">
            {{ "欠薪金额" }}&nbsp;:&nbsp;{{ logIdList.arrearsAmount }}
          </div>
          <div class="text item">
            {{ "欠薪时间" }}&nbsp;:&nbsp;{{ logIdList.wageArrearsStart }} 至 {{ logIdList.wageArrearsEnd }}
          </div>
          <div class="text item">
            {{ "备注" }}&nbsp;:&nbsp;{{ logIdList.remarks }}
          </div>
          <div class="sub-title second" v-if="logIdList.processAttachments">附件</div>
          <div class="fujian" v-for="value in logIdList.processAttachments" :key="value.fileId" >
            <div class="boxs" v-if="value.fileType === 1">
              <img :src="value.fileUrl" alt="" @click="handlePreview(value.fileUrl)">
              <span>{{ value.fileName }}</span>
            </div>
            <div class="boxs" v-else-if="value.fileType === 2">
              <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/pdf.png" alt="">
              <span>{{ value.fileName }}</span>
            </div>
            <div class="boxs" v-else-if="value.fileType === 3">
              <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/word.png" alt="">
              <span>{{ value.fileName }}</span>
            </div>
            <div class="boxs" v-else>
              <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/default-file.png" alt="">
              <span>{{ value.fileName }}</span>
            </div>
          </div>
        </div>
  
        <div class="sub white">
          <div class="sub-title">退回表单</div>
          <el-form ref="formRef" :model="form" :label-position="'top'" :label-width="'auto'">
            <el-form-item label="退回原因">
              <el-input type="textarea" v-model="form.desc" placeholder="请填写退回原因...."></el-input>
            </el-form-item>
            <el-form-item label="退回目标" v-if="!isAdminGoBack">
              <el-select v-model="form.region" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in DispatchList"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
  
            <el-form-item>
              <el-button size="large" @click="handleCancel">取消</el-button>
              <el-button type="danger" @click="handleBack">确认退回</el-button>
            </el-form-item>
          </el-form>
        </div>
  
        <!-- <div class="sub gray">
          <div class="sub-title">处理记录</div>
          <div class="log">
            <div class="log-title"><span class="log-title-dot"></span>已接受投诉</div>
            <div class="log-cont">2023-08-15 15:20<br>投诉已分派至本项目，正在处理中</div>
          </div>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import { getComplaintDetail, getBack } from "@/api/unpaidWages/complaint"
  import {  getGeneralContractorList } from '@/api/public'

  export default {
    name: 'ComplaintVisit',
    data() {
      return {
        id: "0",
        setAssignOptions: {},
        logIdList: {},
        DispatchList: [],
        isAdminGoBack: false,
        form: {
          desc: '',
          region: ''
        }
      }
    },
    mounted() {
      this.id = this.$store.state.attachment.currentId;
      this.setAssignOptions = this.$store.state.attachment.assignOptions;
      console.log('Current ID:', this.id);
      this.getDisposalInfo();
      this.getDispatchListinfo();
    },
    methods: {
      // 处理退回操作
      async handleBack() {
        try {
          if (!this.form.desc) {
            this.$message.warning('请填写退回原因');
            return;
          }
          
          if (!this.isAdminGoBack && !this.form.region) {
            this.$message.warning('请选择退回目标');
            return;
          }

          await this.$msgbox.confirm('确认要退回此投诉吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });

          const backParams = {
            complaintId: this.id,
            processExplain: this.form.desc,
            assignTargetId: this.form.region,
            processType: this.setAssignOptions.assignStatus
          };

          const res = await getBack(backParams);
          
          if (res.code === 200) {
            this.$message.success('退回成功');
            this.$router.push({
              path: '/unpaidWages/complaint/exception',
            });
          } else {
            this.$message.error(res.msg || '退回失败');
          }
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('操作失败');
          }
        }
      },
      
      // 取消按钮处理
      handleCancel() {
        this.form.desc = '';
        this.form.region = '';
        this.$router.push({
          path: '/unpaidWages/complaint/exception',
        });
      },
      
      // 获取处置信息
      async getDisposalInfo() {
        try {
          const res = await getComplaintDetail({id: this.id});
          console.log(res.data);
          this.logIdList = res.data;
        } catch (error) {
          console.error('获取投诉详情失败:', error);
          this.$message.error('获取投诉详情失败');
        }
      },
      
      // 获取退回目标列表
      async getDispatchListinfo() {
        try {
          console.log(this.setAssignOptions);
          let deptTypeList;
          // 1级退回
          if(this.setAssignOptions.assignStatus === 1) {
            deptTypeList = [1];
            this.form.region = '1';
          }
          // 2级退回
          else if(this.setAssignOptions.assignStatus === 2){
            deptTypeList = [2, 3, 4, 5];
            this.form.region = this.setAssignOptions.assignTargetId;
          }
          // 人社局退回
          else if(this.setAssignOptions.assignStatus === 0){
            this.isAdminGoBack = true;
            return;
          }
          const res = await getGeneralContractorList({deptTypeList});
          this.DispatchList = res.data;
          console.log('DispatchList:', this.DispatchList);
        } catch (error) {
          console.error('获取退回目标列表失败:', error);
          this.$message.error('获取退回目标列表失败');
        }
      },
      
      // 下载文件
      handlePreview(file) {
        console.log(file);
      }
    }
  }
  </script>
  
  <style scoped>
  .log {
    clear: both;
    overflow: hidden;
  }

  .log-title-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: blue;
    border-radius: 50%;
    margin-right: 10px;
  }

  .log-title {
    line-height: 30px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .log-cont {
    padding: 10px 0 0 18px;
    color: #666;
  }

  .app-container {
    background: #f7f8f9;
    padding: 20px;
  }

  .el-select .el-input {
    width: 100%;
  }

  .main {
    border-radius: 10px;
    background: #fff;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .main-title {
    font-size: 20px;
    padding: 10px 0 20px;
    font-weight: bold;
    color: #333;
  }

  .sub {
    border-radius: 8px;
    padding: 20px;
    margin: 15px 0;
    font-size: 16px;
    line-height: 28px;
  }

  .sub.blue {
    border: 1px solid #a0c5e8;
    background: #EDF4FDFF;
  }

  .sub.gray {
    border: 1px solid #ddd;
    background: #F7F8F9FF;
  }

  .sub.white {
    border: 1px solid #ddd;
    background: #fff;
  }

  .sub-title {
    font-size: 18px;
    font-weight: bold;
    padding: 0 0 15px 0;
    color: #333;
    border-bottom: 1px solid #eee;
    margin-bottom: 15px;
  }

  .sub-title.second {
    padding-top: 20px;
    margin-top: 20px;
  }

  .text.item {
    margin-bottom: 10px;
    display: flex;
  }

  .fujian {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  
  .fujian .boxs {
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .boxs {
    border: 2px dotted #aaa;
    border-radius: 5px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
  }

  .boxs:hover {
    border-color: #409EFF;
    transform: translateY(-2px);
  }

  .boxs img {
    max-width: 40px;
    max-height: 40px;
    margin-bottom: 5px;
  }

  .boxs span {
    font-size: 12px;
    color: #666;
    text-align: center;
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90px;
  }
  </style>
